import { TextButton } from './styles';

export default TextButton;
